// extracted by mini-css-extract-plugin
export default {"headerWrap":"header_headerWrap__43DiD","logowrap":"header_logowrap__8bzwu","headerRight":"header_headerRight__RfIm+"};